import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import * as theme from "../../../theme";
import TruCard from "../../TruCard";
import ActiveScanItem from "../items/ActiveScanItem";
import { Box, Link } from "@mui/material";

export default function ActiveScanList(props) {
  const [sortedScansList, setSortedScansList] = useState([]);
  const navigate = useNavigate();

  const sortScansByDate = (scans) => {
    return [...scans].sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateA - dateB;
    });
  };

  useEffect(() => {
    if (props && props.activeScansList != null) {
      setSortedScansList(sortScansByDate(props.activeScansList));
    }
  }, [props.activeScansList]);

  return (
    <TruCard title={"Scan Activity"}>
      <div style={theme.Container.listColumn}>
        {sortedScansList.length > 0 ? (
          sortedScansList.map((scan) => (
            <ActiveScanItem
              key={scan.id}
              scan={scan}
              isPractitioner={props.isPractitioner}
              clientName={
                props.clientList.find((c) => c.id === scan.clientId)
                  ? `${props.clientList.find((c) => c.id === scan.clientId).firstName} ${
                      props.clientList.find((c) => c.id === scan.clientId).lastName
                    }`
                  : null
              }
              practitionerName={
                props.practitionerList.find((p) => p.id === scan.practitionerId)
                  ? `${props.practitionerList.find((p) => p.id === scan.practitionerId).firstName} ${
                      props.practitionerList.find((p) => p.id === scan.practitionerId).lastName
                    }`
                  : null
              }
              actionLink={() => navigate(`/clients/${scan.clientId}/scans/${scan.id}`)}
            />
          ))
        ) : (
          <div style={theme.SubHeadingText}>No active scans found.</div>
        )}
      </div>
      <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        <Link
          href="/past-scans"
          underline="hover"
          color="secondary"
          sx={{ cursor: "pointer", fontSize: 14 }}
          onClick={(e) => {
            e.preventDefault();
            navigate("/past-scans");
          }}
        >
          View Past Scans
        </Link>
      </Box>
    </TruCard>
  );
}